
import {observer} from 'mobx-react';
import {Spin} from 'antd';
import {useStore} from '@/store/root-store';
import styled from 'styled-components';
import {LoadingOutlined} from '@ant-design/icons';
import {SidebarTooltip} from '../../../Common/SideBarTooltip/sidebarTooltip';

export const WordCount = observer(() => {
  const secondAntIcon = <LoadingOutlined style={{color: '#7f4ead', marginLeft: '5px', fontSize: 10}}spin />;

  const {
    contentOptimizer: {
      currentPage,
    }} = useStore('');

  const tooltipMsg = (key: string, min?: number, max?: number, cur?: number) => {
    let msg = '';
    if (cur <= min) msg = `Try to use more ${key}. Ideally you should use ${min}-${max} ${key}`;
    if (cur >= max) msg = `Try to use less ${key}. Ideally you should use ${min}-${max} ${key}`;
    if (cur >= min && cur <= max) msg = `Good job. You're in the optimal range.`;
    return msg;
  };

  return <Container>
    Word count:
    {!currentPage?.isWordCountLoading ? <>
      <SidebarTooltip
        placement='bottomRight'
        title={tooltipMsg('words', currentPage?.content?.wordCount, currentPage?.content?.suggestedWordCountLimits?.lower, currentPage?.content?.suggestedWordCountLimits?.upper)}>
        <Dot isWithinRecomendedRange={currentPage?.content?.wordCount >= currentPage?.content?.suggestedWordCountLimits?.lower && currentPage?.content?.wordCount <= currentPage?.content?.suggestedWordCountLimits?.upper}/> </SidebarTooltip>
      {currentPage?.content?.wordCount} </> :
      <Spin indicator={secondAntIcon}/> }
  </Container>;
});


const Container = styled.div`
  font-size: 12px;
  display: flex;
  align-items: center;
  color: #e8e8e8;
  height: 18px;
  cursor: default;
`;
const Dot = styled.div<{isWithinRecomendedRange?: boolean}>`
  width: 4px;
  height: 4px;
  background-color: ${p => p.isWithinRecomendedRange ? '#1aceb3' : '#ff8436'};
  border-radius: 100%;
  display: inline-block;
  margin-bottom: 2px;
  margin-left: 5px;
  margin-right: 5px;
`;
